import React, { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import { Keyboard } from 'react-native'
import { NavigationContainer } from '@src/screens/Common/containers'
import { referralConfigSelector, referralUrlSelector } from '@src/selectors/app'
import { useSnack } from '@src/utils/navigatorContext'
import { Analytics, CustomEventTypes } from '@config'
import { ReferralComponent } from '../components/Referral'

export const ReferralContainer = () => {
  const { message, title, description = '' } = useSelector(referralConfigSelector)
  const referralUrl = useSelector(referralUrlSelector) ?? ''
  const showSnack = useSnack()
  const dispatch = useDispatch()

  const loadingRef = useRef(false)

  const { control, reset, handleSubmit } = useForm({
    mode: 'onBlur',
    defaultValues: {
      email: '',
    },
  })

  const sendInvite = handleSubmit(({ email }) => {
    if (loadingRef.current) {
      return
    }

    loadingRef.current = true

    Keyboard.dismiss()

    dispatch({
      type: 'app/sendUserInvite',
      payload: {
        email,
      },
      success: () => {
        reset({ email: '' })
        loadingRef.current = false
        showSnack('Invite Sent!')
        Analytics.track(CustomEventTypes.ReferralInviteSent)
      },
      failure: () => {
        loadingRef.current = false
        showSnack('Send Failed!', null, 'error')
      },
    })
  })

  return (
    <NavigationContainer title="Refer a Friend">
      <ReferralComponent
        title={title}
        description={description}
        referralUrl={referralUrl}
        sendInvite={sendInvite}
        control={control}
        message={message}
      />
    </NavigationContainer>
  )
}
